import Navigation from "@fae/source/engine/navigating/Navigation.js"
import UserError from "@fae/source/engine/navigating/UserError.js"

import games from "@fae/source/data/games/index.js"
import tests from "@fae/source/data/tests.js"
import main from "@fae/source/data/app.js"
import Preload from "@fae/source/data/preload.js"

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
import Testlaunch from "@fae/source/engine/testing/utility/Testlaunch.js"

////////////////////
// INSTANTIATION //
//////////////////

Navigation.defaultPath = "/splash"

window.fae = window.fae || {}
window.fae.navigation = Navigation

//////////////////
// GAME ROUTES //
////////////////

Navigation.on("/splash", function(request) {
    // TODO: move some of this game-specific logic into the game files!!
    const gameSlug = main.defaultGameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    App.load({"game": {...game}})

    Preload.load({"audios": game.audio})
    Audiomix.trigger(game.titleMusicKey || "Music:Title")
    Audiomix.kill({"label": "ambience"})

    Navigation.state = {"screenKey": "TitleScreen", "gameSlug": gameSlug, "isSplashing": true}

    // if(window.isReturningPlayer) {
    //     Navigation.state = {"screenKey": "TitleScreen", "gameSlug": gameSlug, "isSplashing": false}
    // } else {
    //     Navigation.state = {"screenKey": "EmbarkScreen", "isReturningPlayer": false}
    // }
})

Navigation.on("/games/ember/embark", function(request) {
    const game = games["ember"]
    App.load({"game": {...game}})
    Navigation.state = {"screenKey": "EmbarkScreen", "isReturningPlayer": false}
})

Navigation.on("/title", function(request) {
    const gameSlug = main.defaultGameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    // clearLivePlaytestSavestatesFromGame
    for(chapterSlug of Object.keys(game.chapters)) {
        localStorage.removeItem("savestate_" + gameSlug + "_" + chapterSlug + "_livePlaytest")
    }

    App.load({"game": {
        ...game
    }})

    Preload.load({"audios": game.audio})
    Audiomix.trigger(game.titleMusicKey || "Music:Title")
    Audiomix.kill({"label": "ambience"})
    Navigation.state = {"screenKey": "TitleScreen", "gameSlug": gameSlug, "isSplashing": false}
})

Navigation.on("/games/:gameSlug", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    // clearLivePlaytestSavestatesFromGame
    for(chapterSlug of Object.keys(game.chapters)) {
        localStorage.removeItem("savestate_" + gameSlug + "_" + chapterSlug + "_livePlaytest")
    }

    App.load({"game": {
        ...game
    }})

    Preload.load({"audios": game.audio})
    Audiomix.trigger(game.titleMusicKey || "Music:Title")
    Audiomix.kill({"label": "ambience"})
    Navigation.state = {"screenKey": "TitleScreen", "gameSlug": gameSlug, "isSplashing": true}
})

Navigation.on("/games/:gameKey/reload", function(request) {
    const gameKey = request.wildcards.gameKey

    let game = games[gameKey]
    if(game == undefined) throw new UserError("Could not find game:", gameKey)

    let savestate
    try {
        savestate = JSON.parse(localStorage.getItem(game.key + "_savegame"))
    } catch(error) {
        console.warn("No valid savegame in localstorage. Redirecting...", error)
        Navigation.redirect("/games/" + gameKey)
        return
    }

    console.info("Reloading game from save...", savestate)

    // game = {...game, ...savestate.game}

    window.savestate = savestate // WHAT THE FUCK
    Navigation.redirect(savestate.navigationPath || "/games/" + gameSlug)
})

Navigation.on("/savestates/:savestateSlug", function(request) {
    const savestateSlug = request.wildcards.savestateSlug

    let savestate = localStorage.getItem(savestateSlug)
    if(savestate == undefined) throw new UserError("Could not find savestate:", savestateSlug)
    try {
        savestate = JSON.parse(savestate)
    } catch(error) {
        throw new UserError("Could not parse savestate")
    }

    // {
    //     "name": key,
    //     "captureDate": Date.now(),
    //
    //     "gameSlug": App.game.key,
    //     "chapterSlug": App.game.chapter.key,
    //     "randomSeed": App.game.chapter.originalSeed,
    //
    //     "player": App.game.player,
    //     "data": data,
    // }

    // Preload.load({"audios": game.audio})

    const game = games[savestate.gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", savestate.gameSlug)

    const chapter = game.chapters[savestate.chapterSlug]
    if(chapter == undefined) throw new UserError("Could not find chapter:", savestate.chapterSlug)

    App.load({"game": {
        ...game,
        chapter,
        "deltastageSum": savestate.deltastageSum,
        "player": savestate.player,
        "randomSeed": savestate.randomSeed
    }})
    Navigation.state = {"screenKey": "ChapterScreen", "gameSlug": savestate.gameSlug, "chapterSlug": savestate.chapterSlug}
})

Navigation.on("/games/:gameSlug/title", function(request) {
    const gameSlug = request.wildcards.gameSlug

    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    // clearLivePlaytestSavestatesFromGame
    for(chapterSlug of Object.keys(game.chapters)) {
        localStorage.removeItem("savestate_" + gameSlug + "_" + chapterSlug + "_livePlaytest")
    }
    App.load({"game": {
        ...game
    }})

    Preload.load({"audios": game.audio})
    Audiomix.trigger(game.titleMusicKey || "Music:Title")
    Audiomix.kill({"label": "ambience"})
    Navigation.state = {"screenKey": "TitleScreen", "gameSlug": gameSlug, "isSplashing": false}
})

Navigation.on("/games/:gameSlug/chapters/:chapterSlug", function(request) {
    const key = request.wildcards.chapterSlug
    const gameSlug = request.wildcards.gameSlug

    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)
    const chapter = game.chapters[key]
    if(chapter == undefined) throw new UserError("Could not find chapter:", key)

    Preload.load({"audios": game.audio})
    App.load({"game": {...game, chapter}})
    Navigation.state = {"screenKey": "ChapterScreen", "gameSlug": gameSlug, "chapterSlug": key}

    if(window.location.search.includes("development") == true
    || window.location.search.includes("playtest") == true) {
        if(Dev.mode == "scripts") Dev.readScriptFile()
    }

    if(window.location.search.includes("playtest") == true) {
        Dev.reloadSavestate("livePlaytest", {"rejectStaleSavestates": true})
    }
})

Navigation.on("/games/:gameSlug/chapters/:chapterSlug/encounters/:encounterSlug", function(request) {
    const key = request.wildcards.chapterSlug
    const gameSlug = request.wildcards.gameSlug
    const encounterSlug = request.wildcards.encounterSlug

    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)
    const chapter = game.chapters[key]
    if(chapter == undefined) throw new UserError("Could not find chapter:", key)

    Preload.load({"audios": game.audio})
    App.load({"game": {...game, chapter}})

    if(encounterSlug == (chapter.startingEncounter || 1)) {
        App.game.chapter.restart()
    } else {
        const isSuccessfulReload = Dev.reloadSavestate("advanceToEncounter" + encounterSlug)
        if(isSuccessfulReload == false) {
            const stage = App.game.chapter.stage
            stage.currentEncounterKey = encounterSlug
            const selection = App.game.chapter.selection
            selection.camera.position = selection.calculateNextCameraPosition(stage)
        }
    }

    Navigation.state = {"screenKey": "ChapterScreen", "gameSlug": gameSlug, "chapterSlug": key, "encounterSlug": encounterSlug}
})

Navigation.on("/games/:gameSlug/party", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    Preload.load({"audios": game.audio})
    App.load({"game": {...game}})
    Navigation.state = {"screenKey": "PartyScreen"}
})

Navigation.on("/games/:gameSlug/overworld", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    Preload.load({"audios": game.audio})
    App.load({"game": {...game}})
    Navigation.state = {"screenKey": "OverworldScreen"}
})

Navigation.on("/games/:gameSlug/missions", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    Audiomix.trigger("Music:5") // book
    Preload.load({"audios": game.audio})
    App.load({"game": {...game}})
    Navigation.state = {"screenKey": "MissionScreen"}
})

Navigation.on("/games/:gameSlug/overworlds/:overworldKey", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const overworldKey = request.wildcards.overworldKey
    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    Preload.load({"audios": game.audio})
    App.load({"game": {...game}})
    Navigation.state = {"screenKey": "OverworldScreen", "overworldKey": overworldKey}
})

Navigation.on("/credits", function(request) {
    // Audiomix.trigger(game.titleMusicKey || "Music:Title")
    // Audiomix.kill({"label": "ambience"})
    Navigation.state = {"screenKey": "CreditsScreen"}
})

Navigation.on("/games/:gameSlug/credits", function(request) {
    const gameSlug = request.wildcards.gameSlug

    const game = games[gameSlug]
    if(game == undefined) throw new UserError("Could not find game:", gameSlug)

    App.game = game

    Preload.load({"audios": game.audio})
    Audiomix.trigger(game.titleMusicKey || "Music:Title")
    Audiomix.kill({"label": "ambience"})
    Navigation.state = {"screenKey": "CreditsScreen", "gameSlug": gameSlug}
})

/////////////////
// DEV ROUTES //
///////////////

Navigation.on("/dev", function(request) {
    Navigation.state = {"screenKey": "DevHellScreen"}
})

Navigation.on("/dev/tip", function(request) {
    Navigation.state = {"screenKey": "DevTipScreen"}

    Dev.DateOfLastDevTip = Date.now()
    localStorage.setItem("DateOfLastDevTip", Dev.DateOfLastDevTip)
})

Navigation.on("/dev/tests", function(request) {
    //Testlaunch.perform(tests)
    Navigation.state = {"screenKey": "DevTestListScreen"}
})

Navigation.on("/dev/qa", function(request) {
    //Testlaunch.perform(tests)
    Navigation.state = {"screenKey": "DevQualityAssuranceScreen"}
})

Navigation.on("/dev/tests/:testkey", function(request) {
    const testkey = request.wildcards.testkey
    const test = tests.find((test) => test.key == testkey)
    if(test == undefined) {
        throw new UserError("Could not find test " + testkey)
    }
    Testlaunch.perform(test)
    Navigation.state = {"screenKey": "DevTestScreen", "test": test}
})

import savetests from "@fae/source/data/games/savetests.js"
Navigation.on("/dev/savetests/:testkey", function(request) {
    const testkey = request.wildcards.testkey
    const test = savetests[testkey]
    if(test == undefined) {
        throw new UserError("Could not find test " + testkey)
    }
    //Testlaunch.perform(test)
    if(test.status == undefined) {
        const game = games[test.gameSlug]
        const chapter = game.chapters[test.chapterSlug]
        App.load({"game": {...game, chapter}})
        Dev.inProtoMode = false
        test.status = Dev.replaySavestate(test) ? "good" : "bad"
    }
    Navigation.state = {"screenKey": "DevSavetestScreen", "test": test}
})

Navigation.on("/dev/ui", function(request) {
    Navigation.state = {"screenKey": "DevUiListScreen"}
})

Navigation.on("/dev/ui/:uikey", function(request) {
    Navigation.state = {"screenKey": "DevUiScreen", "uikey": request.wildcards.uikey}
})

Navigation.on("/dev/imports", function(request) {
    Navigation.state = {"screenKey": "DevImportsScreen"}
})

Navigation.on("/dev/scripts/import", function(request) {
    Navigation.state = {"screenKey": "DevScriptImporterScreen"}
})

Navigation.on("/dev/experiment", function(request) {
    Navigation.state = {"screenKey": "DevExperimentScreen"}
})

Navigation.on("/dev/units", function(request) {
    Navigation.state = {"screenKey": "DevUnitListScreen"}
})

Navigation.on("/dev/chapters", function(request) {
    Navigation.state = {"screenKey": "DevChapterListScreen"}
})

Navigation.on("/dev/encounterEditor", function(request) {
    Dev.areDevPanelsOpen = true
    Navigation.state = {"screenKey": "DevEncounterEditorScreen"}
})

//////////////////
// MISC ROUTES //
////////////////

Navigation.on("/screens/:screenName", function(request) {
    Navigation.state = {"screenKey": request.wildcards.screenName}
})

Navigation.on("/*", function(request) {
    throw new UserError("Could not find " + request.path)
})

Navigation.onUserError = function(request) {
    Navigation.state = {"screenKey": "ErrorScreen", "message": request.error.message}
}
Navigation.onError = function(request) {
    Navigation.state = {"screenKey": "ErrorScreen", "message": "Something went wrong!!"}
}

export default Navigation
